import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import {
  DEFAULT_SPACING_SIZE,
  spacingSize,
} from 'hb-builder/components/BuilderComponents/shared/common/spacingSize';
import { getJustifyContent } from 'hb-builder/utils/attributes';
import type {
  BUTTONS_SPACING_OPTIONS,
  WrapperItemAttributes,
} from 'hb-react/backoffice/types/builder/itemAttributes/wrapperItemAttributes';

const WrapperUI = ({
  attributes,
  boxProps,
  children,
  hasMultipleChildren,
}: {
  attributes?: WrapperItemAttributes;
  boxProps?: { [key: string]: any };
  children: ReactNode;
  hasMultipleChildren: boolean;
}) => (
  <ChildrenSpacingWrapper
    $childrenSpacing={attributes?.childrenSpacing || DEFAULT_SPACING_SIZE}
    $isTied={attributes?.tied}
    $hasMultipleChildren={hasMultipleChildren}
    data-testid="builder-component-wrapper"
    flexDirection={attributes?.flexDirection}
    height="100%"
    justifyContent={getJustifyContent(attributes?.horizontalAlign)}
    {...boxProps}
  >
    {children}
  </ChildrenSpacingWrapper>
);

export default WrapperUI;

interface ChildrenSpacingWrapperProps {
  $childrenSpacing: BUTTONS_SPACING_OPTIONS;
  $hasMultipleChildren: boolean;
  $isTied: boolean;
}

const ChildrenSpacingWrapper = styled(Box).attrs({
  flexWrap: 'wrap',
})<ChildrenSpacingWrapperProps>`
  ${({ $childrenSpacing, $hasMultipleChildren, $isTied }) =>
    `
    gap: ${spacingSize[$childrenSpacing] || DEFAULT_SPACING_SIZE}px;
    > div {
      width: ${!$isTied && !$hasMultipleChildren ? '' : 'auto !important'};
      max-width: ${
        /* Truncate text btn if only one button */
        !$isTied && !$hasMultipleChildren && '100%'
      };
    }`}
`;
